<template>
  <div class="google-translator">
    <button
      v-for="country in countries"
      :key="country.code"
      class="google-translator__item"
      type="button"
      @click="translate(country.code)"
    >
      <img
        v-if="country.flagIconUrl"
        class="google-translator__flag"
        :src="country.flagIconUrl"
        :alt="country.altText || country.title"
      >
      <span>{{ country.title }}</span>
    </button>
  </div>
</template>

<script>
export default {
  name: 'GoogleTranslator',
  props: {
    countries: {
      type: Array,
      required: true,
    },
  },
  emits: ['on-country-click'],
  methods: {
    translate(code, attempt = 0) {
      const combo = document.querySelector('select.goog-te-combo');
      const canTranslate = typeof window.doGTranslate === 'function' && combo && combo.innerHTML.length > 0;

      if (canTranslate && typeof code === 'string' && code.includes('|')) {
        window.doGTranslate(code);
        this.$emit('on-country-click', code);
        return;
      }

      if (attempt < 12) {
        setTimeout(() => this.translate(code, attempt + 1), 500);
        return;
      }

      console.error('Google Translate ainda nao foi carregado ou nao criou o seletor interno.');
    },
  },
};
</script>

<style scoped>
.google-translator {
  display: grid;
  gap: 10px;
}

.google-translator__item {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 12px 16px;
  border: 1px solid #0479bf;
  border-radius: 10px;
  color: #0479bf;
  background: #ffffff;
  cursor: pointer;
  transition: all 0.2s ease;
}

.google-translator__item:hover {
  color: #ffffff;
  background: #0479bf;
}

.google-translator__flag {
  width: 28px;
  height: 20px;
  object-fit: cover;
}

</style>
